
import React from "react";
import { TableRow, TableHead } from "@/components/ui/table";
import { ArrowUp, ArrowDown } from "lucide-react";
import { SortDirection } from "@/hooks/useWorksheetFiltering";

interface WorksheetCheckTableHeaderProps {
  sortField: string;
  sortDirection: SortDirection;
  onSort: (field: string) => void;
}

export const WorksheetCheckTableHeader: React.FC<WorksheetCheckTableHeaderProps> = ({
  sortField,
  sortDirection,
  onSort
}) => {
  const SortableHeader: React.FC<{ field: string; label: string }> = ({ field, label }) => {
    const isActive = sortField === field;
    
    return (
      <TableHead 
        className="cursor-pointer hover:bg-gray-100 transition-colors"
        onClick={() => onSort(field)}
      >
        <div className="flex items-center gap-1">
          {label}
          {isActive && (
            sortDirection === "asc" ? 
              <ArrowUp className="h-4 w-4" /> : 
              <ArrowDown className="h-4 w-4" />
          )}
        </div>
      </TableHead>
    );
  };

  return (
    <TableRow>
      <SortableHeader field="teaching_date" label="วัน/เวลา ที่สอน" />
      <SortableHeader field="teacher_display" label="ครูผู้สอน" />
      <SortableHeader field="subject" label="วิชา" />
      <SortableHeader field="teaching_content" label="หัวข้อที่เรียน" />
      <SortableHeader field="student_full_name" label="ชื่อนักเรียน" />
      <SortableHeader field="student_grade_level" label="ชั้นปี" />
      <TableHead>Worksheet</TableHead>
      <TableHead>Worksheet Drive Link</TableHead>
      <SortableHeader field="approved_worksheet_status" label="สถานะ" />
    </TableRow>
  );
};
